module.exports = __webpack_public_path__ + "a549deb63e394fb2276143f5e2174ac9.png";